<template>
	<!-- 顶部导航栏 -->
	<header class="top-nav" id="top-nav">
		<div class="nav-container">
			<div class="logo" @click="$router.replace({path: '/'})">
				<img src="../assets/logo.png" alt="3D鞋壳数字">
			</div>
		</div>
		<div class="nav-search-login-register-pc">
			<div class="userInfo" v-if="userId">
				<el-popover placement="bottom" trigger="hover">
					<div class="logoutBox"
						style="width: 1.36rem;background: rgba(31, 32, 39, 1);display: flex;flex-direction: column;align-items: center;">
						<img class="logoutAvatar"
							style="width: .64rem;height: .64rem;border-radius: 50%;object-fit: cover;"
							:src="userInfo.avatar" v-if="userInfo.avatar" />
						<img class="logoutAvatar"
							style="width: .64rem;height: .64rem;border-radius: 50%;object-fit: cover;"
							src="../assets/defaultAvatar.png" v-else />
						<div class="userName"
							style="margin-top: .12rem;font-weight: 500;font-size: .16rem;color: rgba(255, 255, 255, .8);line-height: .24rem;">
							{{userInfo.user_nickname}}
						</div>
						<div class="logout"
							style="margin-top: .16rem;width: 1.08rem;height: .36rem;border-radius: .06rem;border: .01rem solid rgba(152, 232, 62, 1);font-weight: 400;font-size: .14rem;color: rgba(152, 232, 62, 1);text-align: center;line-height: .36rem;cursor: pointer;"
							@click="logout">
							退出登录</div>
					</div>
					<div class="avatarBox" slot="reference">
						<img class="avatar" :src="userInfo.avatar" v-if="userInfo.avatar" />
						<img class="avatar" src="../assets/defaultAvatar.png" v-else />
					</div>
				</el-popover>
				<div class="personalCenter">
					<router-link to="/personal-center">个人中心</router-link>
				</div>
			</div>
			<div class="nav-login-register" v-else>
				<div class="nav-login">
					<router-link to="/login">登录</router-link>
				</div>
				<div class="nav-register">
					<router-link to="/register">注册</router-link>
				</div>
			</div>
		</div>
		<div class="nav-search-login-register-phone">
			<div class="userInfo" v-if="userId">
				<el-popover placement="bottom" trigger="hover">
					<div class="logoutBox"
						style="width: 2.72rem;background: rgba(31, 32, 39, 1);display: flex;flex-direction: column;align-items: center;">
						<img class="logoutAvatar"
							style="width: 1.28rem;height: 1.28rem;border-radius: 50%;object-fit: cover;"
							:src="userInfo.avatar" v-if="userInfo.avatar" />
						<img class="logoutAvatar"
							style="width: 1.28rem;height: 1.28rem;border-radius: 50%;object-fit: cover;"
							src="../assets/defaultAvatar.png" v-else />
						<div class="userName"
							style="margin-top: .24rem;font-weight: 500;font-size: .32rem;color: rgba(255, 255, 255, .8);line-height: .48rem;">
							{{userInfo.user_nickname}}
						</div>
						<div class="logout"
							style="margin-top: .32rem;width: 2.16rem;height: .72rem;border-radius: .12rem;border: .01rem solid rgba(152, 232, 62, 1);font-weight: 400;font-size: .28rem;color: rgba(152, 232, 62, 1);text-align: center;line-height: .72rem;cursor: pointer;"
							@click="logout">
							退出登录</div>
					</div>
					<div class="avatarBox" slot="reference">
						<img class="avatar" :src="userInfo.avatar" v-if="userInfo.avatar" />
						<img class="avatar" src="../assets/defaultAvatar.png" v-else />
					</div>
				</el-popover>
				<div class="personalCenter" v-if="$route.path != '/personal-center-phone'">
					<router-link :to="!isPhone ? '/personal-center' : '/personal-center-phone'">个人中心</router-link>
				</div>
			</div>
			<div class="nav-login-register" v-else>
				<div class="nav-login">
					<router-link to="/login">登录</router-link>
				</div>
				<div class="nav-register">
					<router-link to="/register">注册</router-link>
				</div>
			</div>
		</div>
	</header>
</template>

<script>
	export default {
		name: 'TopNavBar',
		data() {
			return {
				keywords: '',
				userInfo: {},
				searchPop: false,
				userId: '',
				isPhone: window.innerWidth <= 480 ? true : false,
			}
		},
		mounted() {
			if (localStorage.getItem('token')) {
				this.userId = localStorage.getItem('userId')
				this.userDetails()
			}
		},
		methods: {
			userDetails() {
				this.$api.post('/UserD/user_details', {}).then(res => {
					if (res.code == 1) {
						this.userInfo = res.data
					} else {
						console.log(res.msg)
					}
				}).catch(err => {
					console.log(err);
				})
			},
			naviToCreatorFlowerMarket() {
				this.$router.push({
					path: '/creator-flower-market',
					query: {
						keywords: this.keywords
					}
				})
				this.searchPop = false
				this.keywords = ''
			},
			logout() {
				localStorage.clear();
				this.$store.dispatch('updateShopStatus', 1)
				this.$router.replace({
					path: '/login'
				})
			}
		}
	}
</script>

<style lang="scss" scoped>
	/* 顶部导航栏样式 */

	@media (max-width: 480px) {
		.top-nav {
			position: sticky;
			top: 0;
			height: 1rem;
			display: flex;
			align-items: center;
			justify-content: space-between;
			background-color: rgba(31, 32, 39, 1);
			box-shadow: inset 0px 0px 0px 0px rgba(126, 62, 11, 0.15);
			z-index: 99;
		}

		.nav-container {
			max-width: 12rem;
			display: flex;
			align-items: center;
			height: 1.6rem;
		}

		.logo {
			display: flex;
			width: 2.8rem;
			height: .72rem;
			margin-left: .4rem;
			cursor: pointer;

			img {
				width: 100%;
				height: 100%;
			}
		}

		.nav-search-login-register-pc {
			display: none;
		}

		.nav-search-login-register-phone {
			display: flex;
			align-items: center;
		}

		.userInfo {
			display: flex;
			align-items: center;

			.avatar {
				margin-right: .4rem;
				width: .8rem;
				height: .8rem;
				border-radius: 50%;
				object-fit: cover;
				cursor: pointer;
			}

			.personalCenter {
				margin-right: .4rem;
				width: 2.2rem;
				height: .92rem;
				background: rgba(22, 115, 230, 1);
				border-radius: .46rem;
				font-weight: 500;
				font-size: .28rem;
				color: rgba(255, 255, 255, 1);
				line-height: .92rem;
				text-align: center;

				a {
					display: inline-block;
					width: 2.2rem;
					line-height: .92rem;
					color: rgba(255, 255, 255, 1);
				}

				a:hover {
					text-decoration: none;
				}
			}
		}

		.nav-login-register {
			display: flex;
			align-items: center;
			margin-right: .4rem;

			.nav-login,
			.nav-register {
				margin-left: .48rem;
				width: 2.2rem;
				height: .92rem;
				font-weight: 400;
				font-size: .32rem;
				border-radius: .46rem;
				color: rgba(255, 255, 255, 1);
				text-align: center;
				line-height: .92rem;
				cursor: pointer;

				a {
					display: inline-block;
					color: rgba(255, 255, 255, 1);
					width: 1.1rem;
					line-height: .92rem;
				}

				a:hover {
					text-decoration: none;
				}
			}

			.nav-login {
				border: .01rem solid #FFFFFF;
			}

			.nav-register {
				background: rgba(22, 115, 230, 1);
			}
		}
	}

	@media (min-width: 1921px) {
		.top-nav {
			position: sticky;
			top: 0;
			height: .52rem;
			display: flex;
			align-items: center;
			justify-content: space-between;
			background-color: rgba(31, 32, 39, 1);
			box-shadow: inset 0px 0px 0px 0px rgba(126, 62, 11, 0.15);
			z-index: 99;
		}

		.nav-container {
			max-width: 12rem;
			display: flex;
			align-items: center;
			height: .8rem;
		}

		.logo {
			display: flex;
			width: 1.4rem;
			height: .36rem;
			margin-left: 1.2rem;
			cursor: pointer;

			img {
				width: 100%;
				height: 100%;
			}
		}

		.nav-search-login-register-phone {
			display: none;
		}

		.nav-search-login-register-pc {
			display: flex;
			align-items: center;
		}

		.userInfo {
			display: flex;
			align-items: center;

			.avatar {
				width: .4rem;
				height: .4rem;
				border-radius: 50%;
				object-fit: cover;
				cursor: pointer;
			}

			.personalCenter {
				margin-left: .36rem;
				margin-right: 1rem;
				width: 1.1rem;
				height: .52rem;
				background: rgba(22, 115, 230, 1);
				border-radius: .26rem;
				font-weight: 500;
				font-size: .14rem;
				color: rgba(255, 255, 255, 1);
				line-height: .52rem;
				text-align: center;

				a {
					display: inline-block;
					width: 1.1rem;
					line-height: .52rem;
					color: rgba(255, 255, 255, 1);
				}

				a:hover {
					text-decoration: none;
				}
			}
		}

		.nav-login-register {
			display: flex;
			align-items: center;
			margin-right: 1rem;

			.nav-login,
			.nav-register {
				margin-left: .24rem;
				width: 1.1rem;
				height: .46rem;
				font-weight: 400;
				font-size: .16rem;
				border-radius: .23rem;
				color: rgba(255, 255, 255, 1);
				text-align: center;
				line-height: .46rem;
				cursor: pointer;

				a {
					display: inline-block;
					color: rgba(255, 255, 255, 1);
					width: 1.1rem;
					line-height: .46rem;
				}

				a:hover {
					text-decoration: none;
				}
			}

			.nav-login {
				border: .01rem solid #FFFFFF;
			}

			.nav-register {
				background: rgba(22, 115, 230, 1);
			}
		}
	}

	@media (min-width: 481px) and (max-width: 1920px) {
		.top-nav {
			position: sticky;
			top: 0;
			height: .52rem;
			display: flex;
			align-items: center;
			justify-content: space-between;
			background-color: rgba(31, 32, 39, 1);
			box-shadow: inset 0px 0px 0px 0px rgba(126, 62, 11, 0.15);
			z-index: 99;
		}

		.nav-container {
			max-width: 12rem;
			display: flex;
			align-items: center;
			height: .8rem;
		}

		.logo {
			display: flex;
			width: 1.4rem;
			height: .36rem;
			margin-left: 3.6rem;
			cursor: pointer;

			img {
				width: 100%;
				height: 100%;
			}
		}

		.nav-search-login-register-phone {
			display: none;
		}

		.nav-search-login-register-pc {
			display: flex;
			align-items: center;
		}

		.userInfo {
			display: flex;
			align-items: center;

			.avatar {
				width: .4rem;
				height: .4rem;
				border-radius: 50%;
				object-fit: cover;
				cursor: pointer;
			}

			.personalCenter {
				margin-left: .36rem;
				margin-right: 3.6rem;
				width: 1.1rem;
				height: .52rem;
				background: rgba(22, 115, 230, 1);
				border-radius: .26rem;
				font-weight: 500;
				font-size: .14rem;
				color: rgba(255, 255, 255, 1);
				line-height: .52rem;
				text-align: center;

				a {
					display: inline-block;
					width: 1.1rem;
					line-height: .52rem;
					color: rgba(255, 255, 255, 1);
				}

				a:hover {
					text-decoration: none;
				}
			}
		}

		.nav-login-register {
			display: flex;
			align-items: center;
			margin-right: 3.6rem;

			.nav-login,
			.nav-register {
				margin-left: .24rem;
				width: 1.1rem;
				height: .46rem;
				font-weight: 400;
				font-size: .16rem;
				border-radius: .23rem;
				color: rgba(255, 255, 255, 1);
				text-align: center;
				line-height: .46rem;
				cursor: pointer;

				a {
					display: inline-block;
					color: rgba(255, 255, 255, 1);
					width: 1.1rem;
					line-height: .46rem;
				}

				a:hover {
					text-decoration: none;
				}
			}

			.nav-login {
				border: .01rem solid #FFFFFF;
			}

			.nav-register {
				background: rgba(22, 115, 230, 1);
			}
		}
	}

	.searchPop {
		position: fixed;
		top: 0;
		left: 0;
		width: 100%;
		height: 100vh;
		display: flex;
		align-items: center;
		justify-content: center;
		background: rgba(0, 0, 0, 0.5);
		z-index: 1;

		.centerContent {
			width: 7.4rem;
			display: flex;
			align-items: center;
			justify-content: space-between;
			background: #FFFFFF;
			border-radius: .12rem;

			input {
				margin-left: .2rem;
				width: 5.72rem;
				height: .74rem;
				font-weight: 500;
				font-size: .18rem;
				padding: 0 0;
				border: none;
			}

			.search {
				width: 1.2rem;
				height: .74rem;
				background: #E29358;
				border-radius: .12rem;
				line-height: .74rem;
				text-align: center;
				cursor: pointer;
			}
		}
	}
</style>
<style>
	.el-popover {
		border: none !important;
		min-width: unset !important;
		padding: .24rem 0 .2rem !important;
		background: rgba(31, 32, 39, 1) !important;
	}

	.popper__arrow::after {
		border-left-color: rgba(31, 32, 39, 1) !important;
		border-bottom-color: rgba(31, 32, 39, 1) !important;
	}
</style>